import { useState } from 'react'
import { Subtitle, TextareaField } from 'src/components'
import { decrypt, encrypt } from 'src/utils/crypto'

export default function AdminClientCrypto() {
  const [state, setState] = useState({
    encrypt: '',
    decrypt: '',
    encryptError: false,
    decryptError: false,
  })
  const encryptChange = (value: string) => {
    try {
      const code = encrypt(value)
      setState({
        encryptError: !value ? false : !(value && code),
        decryptError: false,
        encrypt: value,
        decrypt: value.trim() ? code : '',
      })
    } catch (_) {
      setState({
        encryptError: true,
        decryptError: false,
        encrypt: value,
        decrypt: '',
      })
    }
  }

  const decryptChange = (value: string) => {
    try {
      const code = decrypt(value)
      setState({
        decryptError: !value ? false : !(value && code),
        encryptError: false,
        decrypt: value,
        encrypt: code,
      })
    } catch (_) {
      setState({
        ...state,
        decryptError: true,
        encryptError: false,
        decrypt: value,
        encrypt: '',
      })
    }
  }

  return (
    <>
      <Subtitle label="Crypto Client" />
      <div className="grid grid-cols-2 gap-6">
        <TextareaField
          label="encrypt"
          classNameInput="h-32"
          value={state.encrypt}
          onChange={encryptChange}
          enabledCopy
          error={state.encryptError}
        />
        <TextareaField
          label="decrypt"
          classNameInput="h-32"
          value={state.decrypt}
          onChange={decryptChange}
          enabledCopy
          error={state.decryptError}
        />
      </div>
    </>
  )
}
